import { Card } from '../../components/Card/Card';
import { ProgressBar } from '../../components/ProgressBar/ProgressBar';
import { kr, signKr } from '../../lib/format';
import type { Goal } from '@budgetx/shared';
import styles from './GoalCard.module.css';

interface Props {
  goal: Goal;
  onDelete(): void;
}

export function GoalCard({ goal, onDelete }: Props) {
  // Latest two non-null amounts across the whole year — "sidste indtastede"
  // og næstsidste, uanset om de ligger før eller efter valgt måned.
  let saved = 0;
  let prev = 0;
  const seen: number[] = [];
  for (let m = 0; m < goal.amounts.length; m++) {
    const v = goal.amounts[m];
    if (v !== null && v !== undefined) seen.push(v);
  }
  if (seen.length > 0) saved = seen[seen.length - 1]!;
  if (seen.length > 1) prev = seen[seen.length - 2]!;

  const monthly = saved - prev;
  const target = goal.target_amount;
  const hasTarget = target !== null && target > 0;
  const pct = hasTarget ? Math.min(100, Math.round((saved / target) * 100)) : 0;
  const note = hasTarget ? (pct >= 100 ? 'Nået 🎉' : 'I gang') : 'Løbende';

  return (
    <Card className={styles.card}>
      <button className={styles.delete} onClick={onDelete} title="Slet opsparing">
        ×
      </button>
      <div className={styles.name}>{goal.name}</div>
      <div className={`${styles.row} ${styles.rowTop}`}>
        <div className={styles.amount}>{kr(saved)}</div>
        <div className={styles.target}>{hasTarget ? `af ${kr(target)}` : 'Uden mål'}</div>
      </div>
      <div className={styles.progress}>
        <ProgressBar percent={pct} size="md" />
      </div>
      <div className={styles.footer}>
        <span className={styles.pctLabel}>
          {hasTarget ? `${pct}%` : '—'} · {note}
        </span>
        <span className={styles.monthly}>{signKr(monthly)}/md.</span>
      </div>
    </Card>
  );
}
